// extracted by mini-css-extract-plugin
module.exports = {"chat":"style_chat__3kLZ6","title-container":"style_title-container__E-R-r","avatar":"style_avatar__1SPMS","title":"style_title__1l1FZ"};